import { apiPaths } from 'api/kinerja/kepala-sekolah/config'
import { useMutationApi, useQueryApi } from 'utils/api'

import type { CustomError } from 'types/custom-error'
import type { ParamsGetPeriodikType } from 'types/kinerja'
import type {
  ParamsGetKsPeriodikDetail,
  ResponseGetKsPeriodikDetail,
  ParamsGetKsPeriodikList,
  ResponseGetKsPeriodikList,
  ResponseGetKsPeriodikType,
  ParamsBulkKsPenilaianPeriodikPegawai,
  ResponseGetKsPeriodikPegawaiDetail,
  ParamsGetKsPeriodikPegawaiDetail,
  ParamsBulkKsSendPeriodikToBkn,
} from 'types/kinerja-ps'
import type { UseMutationOptions, UseQueryOptions } from 'react-query'

export const API_GET_KS_PERIODIK_LIST_QUERY_KEY =
  'API_GET_KS_PERIODIK_LIST_QUERY_KEY'

export function useApiGetKsPeriodikList({
  params,
  options,
}: {
  params: ParamsGetKsPeriodikList
  options?: UseQueryOptions<ResponseGetKsPeriodikList>
}) {
  const { skpYear } = params

  return useQueryApi<ResponseGetKsPeriodikList>(
    `${apiPaths.pengawasSekolah}/penilaian/periodik`,
    {
      axiosConfig: {
        params: {
          skp_year: skpYear,
        },
      },
      queryConfig: {
        ...options,
      },
      queryKey: [API_GET_KS_PERIODIK_LIST_QUERY_KEY, { skpYear }],
    }
  )
}

export const API_GET_PS_PENILAIAN_PERIODIK_TYPE_QUERY_KEY =
  'API_GET_PS_PENILAIAN_PERIODIK_TYPE_QUERY_KEY'

export function useApiGetPenilaianPeriodikTypePS({
  params,
  options,
}: {
  params: ParamsGetPeriodikType
  options?: UseQueryOptions<ResponseGetKsPeriodikType>
}) {
  return useQueryApi(`${apiPaths.penilaian}/periodik/type`, {
    axiosConfig: {
      params: {
        skp_year: params.skpYear,
      },
    },
    queryConfig: {
      useErrorBoundary: false,
      ...options,
    },
    queryKey: [API_GET_PS_PENILAIAN_PERIODIK_TYPE_QUERY_KEY, params.skpYear],
  })
}

export const API_GET_KS_PERIODIK_DETAIL_QUERY_KEY =
  'API_GET_KS_PS_PERIODIK_DETAIL_QUERY_KEY'

export function useApiGetKsPeriodikDetail({
  params,
  options,
}: {
  params: ParamsGetKsPeriodikDetail
  options?: UseQueryOptions<ResponseGetKsPeriodikDetail>
}) {
  const { skpYear, skpMonth } = params

  return useQueryApi<ResponseGetKsPeriodikDetail>(
    `${apiPaths.pengawasSekolah}/penilaian/periodik/detail`,
    {
      axiosConfig: {
        params: {
          skp_year: skpYear,
          skp_month: skpMonth,
        },
      },
      queryConfig: {
        ...options,
      },
      queryKey: [API_GET_KS_PERIODIK_DETAIL_QUERY_KEY, { skpYear, skpMonth }],
    }
  )
}

export const API_GET_KS_PERIODIK_PEGAWAI_DETAIL_QUERY_KEY =
  'API_GET_KS_PERIODIK_PEGAWAI_DETAIL_QUERY_KEY'

export function useApiGetKsPeriodikPegawaiDetail({
  params,
  options,
}: {
  params: ParamsGetKsPeriodikPegawaiDetail
  options?: UseQueryOptions<ResponseGetKsPeriodikPegawaiDetail>
}) {
  const { skpYear, skpMonth, ptkId } = params

  return useQueryApi<ResponseGetKsPeriodikPegawaiDetail>(
    `${apiPaths.pengawasSekolah}/penilaian/periodik/detail/${ptkId}`,
    {
      axiosConfig: {
        params: {
          skp_year: skpYear,
          skp_month: skpMonth,
        },
      },
      queryConfig: {
        ...options,
      },
      queryKey: [
        API_GET_KS_PERIODIK_PEGAWAI_DETAIL_QUERY_KEY,
        { skpYear, skpMonth, ptkId },
      ],
    }
  )
}

export function useApiBulkKsPenilaianPeriodikPegawai(
  opts?: UseMutationOptions<
    unknown,
    CustomError,
    ParamsBulkKsPenilaianPeriodikPegawai
  >
) {
  return useMutationApi<
    unknown,
    CustomError,
    ParamsBulkKsPenilaianPeriodikPegawai
  >(`${apiPaths.pengawasSekolah}/penilaian/periodik/bulk`, {
    axiosConfig: {
      method: 'POST',
    },
    mutationConfig: {
      ...opts,
    },
  })
}

export function useApiBulkKsSendPeriodikToBkn(
  opts?: UseMutationOptions<unknown, CustomError, ParamsBulkKsSendPeriodikToBkn>
) {
  return useMutationApi<unknown, CustomError, ParamsBulkKsSendPeriodikToBkn>(
    `${apiPaths.pengawasSekolah}/penilaian/periodik/send-bkn/bulk`,
    {
      axiosConfig: {
        method: 'POST',
      },
      mutationConfig: {
        ...opts,
      },
    }
  )
}
